const C = require("../constants");

const simpleTableList = (data) => {
    return {
        type: C.SIMPLE_TABLE_LIST,
        data
    }
};

const simpleTableAddOrUpdate = (data) => {
    return {
        type: C.SIMPLE_TABLE_LIST_ADD_OR_UPDATE,
        data
    }
};

const simpleTableDelete = (data) => {
    return {
        type: C.SIMPLE_TABLE_LIST_DELETE,
        data
    }
};

export {
    simpleTableList,
    simpleTableAddOrUpdate,
    simpleTableDelete
};


// WEBPACK FOOTER //
// ./src/actions/SimpleTableDataActions.js